import { render } from "./DisplayTasks.vue?vue&type=template&id=3a49f15c&scoped=true"
import script from "./DisplayTasks.vue?vue&type=script&lang=js"
export * from "./DisplayTasks.vue?vue&type=script&lang=js"

import "./DisplayTasks.vue?vue&type=style&index=0&id=3a49f15c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a49f15c"

export default script